export default "__VITE_ASSET__ChzN8HB6__"